<app-logo-header></app-logo-header>
<div class="main-container">
  <app-public-rounded-container>

    <form [formGroup]="amanOption" [hidden]="!nextStep" >
      <h4 class="card-title text-center"> {{ 'BUYER_INFO.Aman_Instalation.amanOtions' | translate }} </h4>

      <h6 id="d-block" for="options">
        {{ 'BUYER_INFO.Aman_Instalation.ChooseOption' | translate }}:
      </h6>
      <div *ngFor="let option of amanInstallments; let i = index" [attr.data-index]="i">
        <div class="custom-control custom-radio custom-control-inline form-check mb-2">
          <input class="form-check-input" type="radio" [value]="option" formControlName="option">
          <label class="form-check-label d-block">{{option.Months}} {{
            'BUYER_INFO.Aman_Instalation.Months' | translate }}
            - {{ 'BUYER_INFO.Aman_Instalation.MonthlyAmount' | translate }} :
            {{option.MonthlyAmount}}
            - {{ 'BUYER_INFO.Aman_Instalation.AdminFees' | translate }} :
            {{option.AdminFees}}
          </label>
          </div>
      </div>
      <div class="d-flex justify-content-end">
        <button mat-button  class="btn btn-primary" (click)="sendOTP()" [disabled]='amanOption.invalid' >{{
          'BUYER_INFO.Aman_Instalation.Next' | translate }}</button>
      </div>
    </form>

    <form [formGroup]="amanOtp" [hidden]="nextStep">
      <h4 class="card-title text-center"> {{ 'BUYER_INFO.Aman_Instalation.EnterOTP' | translate }} </h4>
      <mat-form-field>
        <mat-label>{{ 'Sellers.Products.EnterOtp' | translate }}</mat-label>
        <input matInput type="text" placeholder="{{ 'Sellers.Products.EnterOtp' | translate }}" formControlName="otp"
          name="otp">
      </mat-form-field>
      <div *ngIf="amanOtp.controls.otp.invalid && (amanOtp.controls.otp.dirty || amanOtp.controls.otp.touched)"
        class="text-danger">

        <div *ngIf="amanOtp.controls.otp.errors?.['required']">
          {{ 'BUYER_INFO.Aman_Instalation.required' | translate }}
        </div>
        <div *ngIf="amanOtp.controls.otp.errors?.['pattern']">
          {{ 'BUYER_INFO.Aman_Instalation.Pattern' | translate }}
        </div>
      </div>
      <div>
        <button mat-button  [disabled]='amanOtp.invalid' class="col-12 btn btn-primary my-2"
          (click)="payment()">
          {{ 'BUYER_INFO.Aman_Instalation.payment' | translate }}
        </button>
        <button class="col-12 btn btn-success" [disabled]="sendCodeClicked" (click)="reSend()">{{
          "Sellers.Products.Resend" | translate }}
          <ng-container *ngIf="sendCodeClicked">
            ({{ timer | async }})
          </ng-container>
        </button>
        <div>{{sendFailed}}</div>
      </div>
    </form>

  </app-public-rounded-container>
</div>
